import { useState, useEffect, useMemo } from "react";
import Icon from "./Icon.jsx";
import { Button } from "react-bootstrap";
import Tooltip from "./ToolTip.jsx";

const typeMapping = (type, name) => {
    switch (type) {
        case "copy":
            return "ContentPasteOutlined";
        case "delete":
            return "DeleteOutlined";
        case "reset":
            return "FastRewind";
        default:
            return name;
    }
}

const IconButton = ({
    type = "",
    name = "",
    title = "",
    tooltip = "",
    size = 24,
    highlight = false,
    onClick = () => { },
    variant = "secondary",
    visible = true,
    disabled = false,
    buttonClassName = "",
    iconClassName = "",
    key = "",
    id = "",
    buttonProps = {},
    iconProps = {},
    tooltipProps = {}
}) => {
    const [iconName, setIconName] = useState(null)

    if (!(type || name)) {
        throw new Error('Required props: type or name');
    }

    useEffect(() => {
        setIconName(typeMapping(type.toLowerCase(), name))
    }, [type, name])

    const button = useMemo(() => {
        if (!iconName) return null;
        return <Button
            className={`p-0 m-0 border-0 ${!highlight ? "bg-transparent" : ""} ${buttonClassName}`}
            title={title}
            key={key}
            variant={`outline-${variant}`}
            disabled={disabled}
            onClick={onClick}
            id={id}
            {...buttonProps}
        >
            <Icon
                icon={iconName}
                className={`p-0 m-0 border-0 d-block ${!highlight ? `text-${variant}` : ""} ${iconClassName}`}
                sx={{ fontSize: size }}
                {...iconProps}
            />
        </Button>
    }, [buttonClassName, buttonProps, disabled, highlight, iconClassName, iconName, iconProps, key, onClick, size, title, variant, id])

    if (!visible) return null;
    if (!tooltip) return button;
    return <Tooltip
        text={tooltip}
        isInline={true}
        {...tooltipProps}
    >
        {button}</Tooltip>;
};

export default IconButton;